import type { CarouselSlide } from '../components/ImageCarousel';

export const CONSULTATION_SCREENSHOTS: CarouselSlide[] = [
  {
    src: '/screenshots/consultation/pravni-orientace-step-1.png',
    alt: 'Právní orientace krok 1',
    caption: 'Vstup do právní orientace z přehledu'
  },
  {
    src: '/screenshots/consultation/pravni-orientace-step-2.png',
    alt: 'Právní orientace krok 2',
    caption: 'Zadání tématu a kontextu'
  },
  {
    src: '/screenshots/consultation/pravni-orientace-step-3.png',
    alt: 'Právní orientace krok 3',
    caption: 'Doplňující otázky od AI'
  },
  {
    src: '/screenshots/consultation/pravni-orientace-step-4.png',
    alt: 'Právní orientace krok 4',
    caption: 'Generování odpovědi s odkazy'
  },
  {
    src: '/screenshots/consultation/pravni-orientace-step-5.png',
    alt: 'Právní orientace krok 5',
    caption: 'Výsledek v přehledné struktuře'
  },
  {
    src: '/screenshots/consultation/pravni-orientace-step-6.png',
    alt: 'Právní orientace krok 6',
    caption: 'Uložená historie a navazující práce'
  }
];

export const CONTRACT_ANALYSIS_SCREENSHOTS: CarouselSlide[] = [
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-1.png',
    alt: 'Analýza smluv krok 1',
    caption: 'Spuštění analýzy v přehledu'
  },
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-2.png',
    alt: 'Analýza smluv krok 2',
    caption: 'Nahrání souboru smlouvy'
  },
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-3.png',
    alt: 'Analýza smluv krok 3',
    caption: 'Volba role smluvní strany'
  },
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-4.png',
    alt: 'Analýza smluv krok 4',
    caption: 'Kontrola parametrů před analýzou'
  },
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-5.png',
    alt: 'Analýza smluv krok 5',
    caption: 'Spuštěná AI analýza'
  },
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-6.png',
    alt: 'Analýza smluv krok 6',
    caption: 'Přehled zjištěných rizik'
  },
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-7.png',
    alt: 'Analýza smluv krok 7',
    caption: 'Detail jednotlivých ustanovení'
  },
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-8.png',
    alt: 'Analýza smluv krok 8',
    caption: 'Souhrn doporučení k ověření'
  },
  {
    src: '/screenshots/contract-analysis/analyza-smluv-step-9.png',
    alt: 'Analýza smluv krok 9',
    caption: 'Uložení a návrat do historie'
  }
];

export const DOCUMENTS_SCREENSHOTS: CarouselSlide[] = [
  {
    src: '/screenshots/documents/generator-smluv-step-1.png',
    alt: 'Generátor smluv krok 1',
    caption: 'Vstup do generátoru smluv z přehledu'
  },
  {
    src: '/screenshots/documents/generator-smluv-step-2.png',
    alt: 'Generátor smluv krok 2',
    caption: 'Výběr typu smlouvy'
  },
  {
    src: '/screenshots/documents/generator-smluv-step-3.png',
    alt: 'Generátor smluv krok 3',
    caption: 'Zadání údajů do formuláře'
  },
  {
    src: '/screenshots/documents/generator-smluv-step-4.png',
    alt: 'Generátor smluv krok 4',
    caption: 'Pokračování vyplnění krok za krokem'
  },
  {
    src: '/screenshots/documents/generator-smluv-step-5.png',
    alt: 'Generátor smluv krok 5',
    caption: 'Kontrola zadaných parametrů'
  },
  {
    src: '/screenshots/documents/generator-smluv-step-6.png',
    alt: 'Generátor smluv krok 6',
    caption: 'Generování finální šablony'
  },
  {
    src: '/screenshots/documents/generator-smluv-step-7.png',
    alt: 'Generátor smluv krok 7',
    caption: 'Náhled vytvořeného dokumentu'
  },
  {
    src: '/screenshots/documents/generator-smluv-step-8.png',
    alt: 'Generátor smluv krok 8',
    caption: 'Revize a úpravy dokumentu'
  },
  {
    src: '/screenshots/documents/generator-smluv-step-9.png',
    alt: 'Generátor smluv krok 9',
    caption: 'Stažení a uložení v přehledu'
  }
];
